module.exports = __webpack_public_path__ + "img/coin_big.61463c9d.svg";